import React from 'react'
import { withRouter } from 'react-router-dom'

import Card from '../../../components/card'
import { AuthContext } from '../../../main/authProvider'
import { Button } from 'primereact/button'

import LancamentoProvisaoComponent from '../../../components/contasAPagar/provisoes/lancamentoProvisaoComponent'
import ConstantsUtil from '../../../context/constantsUtil'


class LancarProvisoesAPagar extends React.Component {

    constructor(){
        super();
        this.lancamentoProvisaoComponentRef = React.createRef();

    }

    state = {

        disableSaveButton: false,

    }



    callSave = () => {
        // quem desabilita/habilita o botão é o próprio LancamentoProvisaoComponent
        this.lancamentoProvisaoComponentRef.current.callSave()
    }

    disableSaveButton = () => {
        this.setState({disableSaveButton: true})
    }

    enableSaveButton = () => {
        this.setState({disableSaveButton: false})
    }

    isRecorrencia = () => {
        return (window.location.pathname === ConstantsUtil.lancarProvisoesRecorrentesPathName)
    }

    isProvisaoAReceber = () => {
        return (window.location.pathname === ConstantsUtil.lancarProvisoesAReceberPathname)
    }

    isProvisaoAPagar = () => {
        return (window.location.pathname === ConstantsUtil.lancarProvisoesAPagarPathname)
    }

    getTitulo = () => {
      if(this.isRecorrencia()){
          return "Lançar Provisões Recorrentes/Estimativa"
      }

      if(this.isProvisaoAReceber()){
          return "Lançar Provisão a Receber"
      }

      return "Lançar Provisão a Pagar"
    }


    render() {
        
        return (
            <div className="bs-docs-section" >

            <Card title = {this.getTitulo()}>
                <div className="col-md-12">

                    <LancamentoProvisaoComponent
                        ref={this.lancamentoProvisaoComponentRef}
                        disableSaveButton={this.disableSaveButton}
                        enableSaveButton={this.enableSaveButton}
                        isLancamento
                        isRecorrencia={this.isRecorrencia()}
                        isProvisaoAPagar={this.isProvisaoAPagar()}
                        isProvisaoAReceber={this.isProvisaoAReceber()}
                    />
                    
                    <br />
                    
                    <Button 
                        label="Salvar Lançamento"
                        icon="pi pi-save"
                        onClick = {this.callSave}
                        // style={ {maxHeight: '35px' } }
                        disabled = {this.state.disableSaveButton}
                    />

                    <br />

                    <br />

                </div>
            </Card>
            <div className="d-flex "/>

        </div>
        )

    }

}

LancarProvisoesAPagar.contextType = AuthContext

export default withRouter(LancarProvisoesAPagar)
